import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'olo-req-int-title';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Will this change involve International Service?',
};

const oloReqIntTitle = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { oloReqIntTitle };
